import React, { useContext } from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { useLocation, useRouteMatch } from "react-router-dom";
import PropTypes from "prop-types";
import SpecialOffer from "app/pages/.shared/SpecialOffer/SpecialOffer";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";

const BookingBannerPlaceholder = ({
	specialOffer,
	fallBackSpecialOffer,
	isSpecialOfferActive,
	disableFlashySpecialOffer,
	ignorePagecheck,
}) => {
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.MEDIUM || resolution === RESOLUTION.SMALL;

	const location = useLocation();
	const match = useRouteMatch();

	const isProductPage = match.path.includes(":productUri");

	const shouldDisplaySpecialOfferOnCurrentPage =
		ignorePagecheck ||
		(specialOffer.pages &&
			specialOffer.pages.find(page => {
				return location.pathname.includes(page) || (page === "product" && isProductPage);
			}));

	const shouldDisplaySpecialOfferFallbackOnCurrentPage =
		fallBackSpecialOffer.pages &&
		fallBackSpecialOffer.pages.find(page => {
			return location.pathname.includes(page) || (page === "product" && isProductPage);
		});

	// ne pas afficher la banniere sur la page sdp quote car c'est intégré via un badge sur la photo
	const isMobileAndSdpQuote = location.pathname.includes("/sdp/booking/quote") && isMobile;

	if (isMobileAndSdpQuote && !ignorePagecheck) {
		return null;
	}

	let spo = undefined;
	if (isSpecialOfferActive && shouldDisplaySpecialOfferOnCurrentPage) {
		spo = specialOffer;
	} else if (!isEmpty(fallBackSpecialOffer) && shouldDisplaySpecialOfferFallbackOnCurrentPage) {
		spo = fallBackSpecialOffer;
	}

	if (spo) {
		return (
			<div className="booking-marketing-placeholder">
				<SpecialOffer
					type={spo.type}
					title={spo.title}
					message={spo.summary}
					background={
						// on force la couleur du texte en noir sur la fiche produit mobile
						disableFlashySpecialOffer ? undefined : get(spo, "ui.background")
					}
					titleColor={get(spo, "ui.titleColor")}
					textColor={isProductPage ? undefined : get(spo, "ui.textColor")}
					pictoUrl={get(spo, "ui.pictoUrl")}
					tooltipMessage={spo.details}
				/>
			</div>
		);
	}

	return null;
};

BookingBannerPlaceholder.propTypes = {
	disableFlashySpecialOffer: PropTypes.object,
	specialOffer: PropTypes.object,
	fallBackSpecialOffer: PropTypes.object,
	ignorePagecheck: PropTypes.bool,
	isSpecialOfferActive: PropTypes.bool,
};

BookingBannerPlaceholder.defaultProps = {
	fallBackSpecialOffer: {},
	specialOffer: {},
};

export default React.memo(BookingBannerPlaceholder);
